import React from 'react';
import { View, Text, Image, StyleSheet, useWindowDimensions, Platform } from 'react-native';
import { COLORS, FONTS, getDeviceType } from '../styles/theme';

export default function Hero() {
  const { width, height } = useWindowDimensions();
  const deviceType = getDeviceType(width);

  const isMobile = deviceType === 'mobile';
  const isTablet = deviceType === 'tablet';
  const isDesktop = !isMobile && !isTablet;
  const getIllustrationHeight = () => {
    if (isMobile) return height * 0.45;
    if (isTablet) return height * 0.55;
    return 'auto'; 
  };

  return (
    <View style={styles.container}>
      
      {/* Contenedor de la pintura */}
      <View style={[
        styles.imageWrapper, 
        { height: getIllustrationHeight() },
        isDesktop && styles.imageWrapperDesktop
      ]}>
        <Image
          source={require('../assets/ilustracion-hero.jpg')}
          style={isDesktop ? styles.heroImageDesktop : styles.heroImage}
          resizeMode={isDesktop ? "cover" : "cover"} 
        />
        <View style={styles.gradientFade} />
      </View>
      <View style={styles.infoContainer}>
        <Text style={[
          styles.title, 
          { fontSize: isMobile ? 36 : isTablet ? 48 : 56 }
        ]}>
          LAURA & LEANDRO
        </Text>
        
        <Text style={[
          styles.date, 
          { fontSize: isMobile ? 16 : 20 }
        ]}>
          19 SEPTIEMBRE 2026
        </Text>
        
        <Text style={[
          styles.location, 
          { fontSize: isMobile ? 18 : 22 }
        ]}>
          Cabra, Córdoba
        </Text>
      </View>
      <View style={[styles.divider, { width: isMobile ? '80%' : '60%' }]} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: COLORS.bgCrema,
    alignItems: 'center',
    paddingTop: Platform.OS === 'web' ? 70 : 60,
  },
  imageWrapper: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  imageWrapperDesktop: {
    aspectRatio: 16 / 9, 
  },
  heroImage: {
    width: '100%',
    height: '100%',
  },
  heroImageDesktop: {
    width: '100%',
    height: '100%',
    ...Platform.select({
      web: {
        objectPosition: 'top center', 
      }
    })
  },
  gradientFade: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 120,
    ...Platform.select({
      web: {
        background: `linear-gradient(to bottom, rgba(247, 244, 239, 0) 0%, ${COLORS.bgCrema} 100%)`,
      },
      default: {
        backgroundColor: 'rgba(247, 244, 239, 0.7)',
      },
    }),
  },
  infoContainer: {
    alignItems: 'center',
    paddingHorizontal: 24,
    marginTop: 20,
  },
  title: {
    fontFamily: FONTS.titulo,
    color: COLORS.negroSuave,
    textAlign: 'center',
    letterSpacing: 2,
    fontWeight: '400',
    marginBottom: 12,
  },
  date: {
    fontFamily: FONTS.cuerpo,
    color: COLORS.negroSuave,
    textAlign: 'center',
    letterSpacing: 3,
    fontWeight: '300',
    marginBottom: 8,
  },
  location: {
    fontFamily: FONTS.titulo,
    color: COLORS.negroSuave,
    textAlign: 'center',
    letterSpacing: 1,
    fontStyle: 'italic',
  },
  divider: {
    height: 1,
    backgroundColor: 'rgba(44, 44, 44, 0.1)',
    marginTop: 40,
    marginBottom: 20,
  },
});